import { render, staticRenderFns } from "./SettingsForm.vue?vue&type=template&id=3e277be1"
import script from "./SettingsForm.vue?vue&type=script&lang=js"
export * from "./SettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports